export default __webpack_public_path__ + "static/filecoin-22616bb03be9b634c8e733d1ae199ae4.png";